import {
  ButtonGroup,
  MenuItem,
  styled,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { StarBorder } from '@mui/icons-material';
import { grey } from '@mui/material/colors';

export const DropdownInnerContent = styled(Typography)`
  padding: 4px 8px;
  letter-spacing: 0.4px;
`;

export const EmptyStar = styled(StarBorder)`
  color: ${({ theme }) => theme.palette.text.secondary}
`;

export const CurrentlyViewingWrapper = styled(MenuItem)`
  &.MuiMenuItem-root {
    all: unset;
    padding-top: 2px;
  }

  display: flex;
  align-items: center;
`;

export const CurrentlyViewingActions = styled(ButtonGroup)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 48px;
  padding-top: 8px;
  padding-bottom: 8px;
`;

export const CurrentlyViewingButton = styled(IconButton)`
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const DropdownLabel = styled(Typography)`
  color: ${grey[700]};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.4px;
  line-height: 20px;
  padding: 0 8px;
  text-align: right;
  text-transform: uppercase;
  text-wrap: nowrap;
`;
